import gql from 'graphql-tag';

export const mutationDeleteRemoteItemPermission = gql`
  mutation deleteRemoteItemPermission (
    $integrationID: DokkioID!
    $email: String
    $permissionID: String
    $remoteItemRemoteID: ID
  ) {
    deleteRemoteItemPermission (
      integrationID: $integrationID
      email: $email
      permissionID: $permissionID
      remoteItemRemoteID: $remoteItemRemoteID
    )
  }
`;
export default mutationDeleteRemoteItemPermission;
